/* eslint-disable indent */
/* eslint-disable no-console */
/* eslint-disable max-len */
import React, { useContext, useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getDocByDocumentId, removeUserOnlineStatus, updateDocByDocumentId, updateMultipleDocuments } from '../../../utils/Firebase/firebaseQuery';
import { getLinkPreview, manageNotifications } from '../../actions/presence_actions';
import { setBroadcastChatUserList, setChatMessages, setChatRoomInfo, setisFireBaseAuth, setPresenceChatUser, setPresenceChatUserList, setUserStatus, setIsChatLoaded, setPeerUserSettings } from '../../../redux/PresenceRedux';
import { addDocumentToIdb, addGroupsToPresenceDb, deleteGroupFromPresenceDb, deleteMessageToLocalDb, getAllGroups, getBroadcastList, getDocumentFromIdb, updateDocumentInIdb, updateEntireGroupData } from '../../../utils/LocalDB';
import { PRESENCE_ENUMS } from '../../../libs/enums/presenceEnums';
import { deleteToken } from 'firebase/messaging';
import { firebaseMessaging } from '../../../utils/Firebase/useFirebase';
import { getAuth, signOut } from 'firebase/auth';
import { store } from '../../../redux/store';
import { CollaborationContext } from '../../../libs/Context';
import { compareObjData } from '../../../libs/HelperContent';
import useCallHelper from '../../../libs/CallHelper';
import { processMessagesForLocalDb, saveMessagesWithTimestamp } from '../../../utils/messageProcessing';

const useMessageHook = (addedMsgs:any = { current: [] }, peerConnectionRef:any = { current: null }, remoteStreamRef:any = { current: null }, localStreamRef:any = { current: null }, reconectionRef:any = { current: null }) =>
{
	// const groupIds = useSelector((state:any) => state?.mypresence?.groupIds);
	const unseenCountUpdate = async (chatInfo, userId) =>
	{
		const groupIds = store.getState()?.mypresence?.groupIds;

		if (chatInfo)
		{
			// const 	item = chatInfo?.membersDetails?.[userId];
			const item = groupIds[chatInfo?.id];

			if (item?.unseenMsgCount > 0 && window.location.pathname?.includes('collaboration'))
			{
				// const updatedObj = { ...item, unseenMsgCount: 0 };

				await updateDocByDocumentId('unseenMessages', userId, { [`groupIds.${chatInfo?.id}.unseenMsgCount`]: 0 });
			}
		}
	};
	const userData = store?.getState()?.mysession?.session;
	const dispatch = useDispatch();
	// const { roomModeView } = store?.getState()?.call;
	const { handleCall, callDbCallBack } = useCallHelper(peerConnectionRef, remoteStreamRef, localStreamRef, reconectionRef);

	// Get user settings from Redux (cached from listeners)
	const currentUserSettings = useSelector((state:any) => state?.mypresence?.currentUserSettings);
	let peerUserSettings = useSelector((state:any) => state?.mypresence?.peerUserSettings);

	const updatedPresenceList = useRef<any[]>([]);
	// const offerTimeoutRef = useRef<any>();

	// const setMsgIndicator = (obj) => { return 'temp'; }; // import from mePresenceSlice
	let initialRender = true;

	// Track pending read status updates when tab is not visible
	const pendingReadUpdateRef = useRef<{
		msgsSentByPeer: any[];
		currentRoomInfo: any;
		reqAccepted: boolean;
	} | null>(null);
	const pendingChatListUpdateRef = useRef<boolean>(false);

	// Utility function to check if document/tab is visible
	const isDocumentVisible = () =>
	{
		return typeof document !== 'undefined' &&
			(document.visibilityState === 'visible' || !document.hidden);
	};

	const checkingLinkPreview = async (message) =>
	{
		if (message?.links?.length > 0 && message?.linkPreviewData && Object.keys(message?.linkPreviewData)?.length === 0)
		{
			const response = await getLinkPreview({ url: message?.links?.[0] });

			if (response?.status)
			{
				const data = {
					title       : response?.results?.title,
					description : response?.results?.description,
					image       : response?.results?.images[0] || response?.results?.favicons[0] || ''
				};

				await updateDocByDocumentId('messages', message?.id, { linkPreviewData: data });
			}
		}
	};

	const handleBroadcastMessages = async (response) =>
	{
		const myPresence = store?.getState()?.mypresence;

		addedMsgs.current = [ ...(myPresence?.chatMessages || []) ];

		const dbMsgs:any = [];

		const updateMessages = (data, index) =>
		{
			// to append new messages or update old messages
			addedMsgs.current = [ ...addedMsgs.current ]; // Deep copy to ensure mutability
			if (index === -1)
			{
				addedMsgs.current?.push(data);
			}
			else
			{
				addedMsgs.current[index] = data;
			}
		};
		const chatIdList:string[] = [];

		response.docChanges().forEach(async (change) =>
		{
			let data = change.doc.data();

			checkingLinkPreview(data);

			const index = addedMsgs.current.findIndex((msg) => msg?.id === data?.id);
			const isInCurrentChat = myPresence?.chatRoomInfo?.id === data?.broadcastId;

			if (index !== -1)
			{
				data = { ...addedMsgs.current[index], ...data };
			}

			// Process message with attachment type and auto-download settings
			const processedMessages = processMessagesForLocalDb([ data ]);

			dbMsgs.push(processedMessages[0]);

			if (change.type === 'added')
			{
				handleCall(data);
				if (data?.chatId?.split('_')?.length > 1 && data?.msgStatus === 1 && data?.senderId !== userData?.userId)
				{
					if (!chatIdList.includes(data?.chatId))
					{
						chatIdList.push(data?.chatId);
					}

					// updating message status as recieved
					await updateDocByDocumentId('messages', data?.id, { msgStatus: 2 });
				}
				isInCurrentChat && updateMessages(data, index);
			}

			if (change.type === 'modified')
			{
				if (isInCurrentChat)
				{
					updateMessages(data, index);
				}
			}

			// Handle call statuses

			// callDbCallBack(data);
		});

		// if (chatIdList?.length > 0)
		// {
		// 	// updating message status in chats list for recieved messages whose status was 1.
		// 	chatIdList.forEach(async (chatId) =>
		// 	{
		// 		await updateDocByDocumentId('broadcastMessages', chatId, { msgStatus: 2 });
		// 	});
		// }
		if (addedMsgs.current.length > 0) dispatch(setChatMessages(addedMsgs.current));
		if (dbMsgs.length > 0)
		{
			try
			{
				// Save messages with timestamp update using shared utility
				await saveMessagesWithTimestamp(dbMsgs);
			}
			catch (error)
			{
				console.error('Error saving broadcast messages to IndexedDB:', error);
			}
		}
	};

	const messagesDbCallback = async (response) =>
	{
		// console.log('message response===========================>', response);
		const myPresence = store?.getState()?.mypresence;

		// addedMsgs - to set all messages in current opened chat
		// will update msgStatus of old chats and new chat and push new msgs in this
		addedMsgs.current = [ ...(myPresence?.chatMessages || []) ];

		// dbMsgs - using this to update localDB messages
		// attachmentType key is being added in newly recieved messages to store in localdb
		const dbMsgs:any = [];

		const updateMessages = (data, index) =>
		{
			// to append new messages or update old messages
			addedMsgs.current = [ ...addedMsgs.current ]; // Deep copy to ensure mutability
			if (index === -1)
			{
				addedMsgs.current?.push(data);
			}
			else
			{
				addedMsgs.current[index] = data;
			}
		};

		// Track message IDs for each group - used for both message and group updates
		// messagesToUpdate - collect all messages that need status update to batch update them
		const messagesToUpdate:any[] = [];
		const groupMessageMap:Map<string, string> = new Map();

		response.docChanges().forEach(async (change) =>
		{
			let data = change.doc.data();

			checkingLinkPreview(data);

			const index = addedMsgs.current.findIndex((msg) => msg?.id === data?.id);
			const isInCurrentChat = myPresence?.chatRoomInfo?.id === data?.chatId;
			const previousMessage = index !== -1 ? addedMsgs.current[index] : null;

			if (index !== -1)
			{
				data = { ...addedMsgs.current[index], ...data };
			}

			// Process message with attachment type and auto-download settings
			const processedMessages = processMessagesForLocalDb([ data ]);

			dbMsgs.push(processedMessages[0]);

			// console.log('data111111==========>', data, change);

			if (change.type === 'added')
			{
				handleCall(data);
				if (data?.chatId?.split('_')?.length > 1 && data?.msgStatus === 1 && data?.senderId !== userData?.userId)
				{
					// Track this message ID for this group (replaces chatIdList and messagesToUpdate)
					if (!groupMessageMap.has(data?.chatId))
					{
						groupMessageMap.set(data?.chatId, data?.id);
					}

					// Collect message for batch update instead of updating individually
					messagesToUpdate.push({ id: data?.id });
				}
				isInCurrentChat && updateMessages(data, index);
			}

			if (change.type === 'modified')
			{
				if (isInCurrentChat)
				{
					updateMessages(data, index);
				}

				if (previousMessage?.msgStatus === 1 && data?.msgStatus === 2 && data?.senderId === userData?.userId && data?.chatId)
				{
					// if previous status was 1(sent) and new status is 2(received), then set the status to 2(received)
					// Track this message ID for this group (replaces groupsToUpdate)
					if (!groupMessageMap.has(data?.chatId))
					{
						groupMessageMap.set(data?.chatId, data?.id);
					}
				}
			}

			// Handle call statuses

			callDbCallBack(data);
		});

		if (addedMsgs.current.length > 0) dispatch(setChatMessages(addedMsgs.current));

		// Batch update messages and groups in parallel using Promise.all
		const updatePromises:Promise<any>[] = [];

		if (messagesToUpdate?.length > 0)
		{
			updatePromises.push(updateMultipleDocuments('messages', messagesToUpdate, { msgStatus: 2 }));
		}
		await Promise.all(updatePromises);

		// Get all groups from groupMessageMap for group updates
		const allGroupsToUpdate = Array.from(groupMessageMap.keys());

		if (allGroupsToUpdate?.length > 0)
		{
			// Map groups with their lastMessageId for conditional update
			const roomsToUpdate = allGroupsToUpdate
				.map((groupId) => ({
					id : groupId
				}));

			if (roomsToUpdate.length > 0)
			{
				setTimeout(() =>
				{
					updatePromises.push(updateMultipleDocuments('groups', roomsToUpdate, { msgStatus: 2 }));
				}, 1000);
			}
		}

		// Execute all updates in parallel
		if (updatePromises.length > 0)
		{
			await Promise.all(updatePromises);
		}
		if (dbMsgs.length > 0)
		{
			try
			{
				// Save messages with timestamp update using shared utility
				await saveMessagesWithTimestamp(dbMsgs);
			}
			catch (error)
			{
				console.error('Error saving messages to IndexedDB:', error);
				// Don't update timestamp if save failed - will retry these messages on next sync
			}
		}
	};

	const handleDeletedData = async (response) =>
	{
		if (response.docChanges().length === 0) return;

		try
		{
			const myPresence = store?.getState()?.mypresence;
			const allChatRoom = [ ...(myPresence?.presenceUserChatList ?? []) ];
			const currentChatMessages = store?.getState()?.mypresence?.chatMessages || []; // Initialize with current state
			let filteredMessages:object[] = [ ...currentChatMessages ];
			const delChatList:object[] = [];
			let isChatDeletedFromCurrentOpenedRoom = false;

			for (const change of response.docChanges())
			{
				const deletedData = change.doc.data();

				if (!deletedData?.messageId)
				{
					console.error('No messageId in deletedData:', deletedData);
					continue; // Skip this iteration if no messageId
				}

				const callMsg:any = currentChatMessages?.find((msg:any) => msg?.callDetails?.sessionId === myPresence?.chatRoomInfo?.sessionId &&
					(msg?.callDetails?.status === PRESENCE_ENUMS.accepted || msg?.callDetails?.status === PRESENCE_ENUMS.connected) &&
					[ PRESENCE_ENUMS.left, PRESENCE_ENUMS.declined, PRESENCE_ENUMS.missed ].includes(msg?.callDetails?.participants[userData?.userId]?.status));

				if (!isChatDeletedFromCurrentOpenedRoom)
				{
					isChatDeletedFromCurrentOpenedRoom = myPresence?.chatRoomInfo?.id === deletedData?.groupId;
				}
				filteredMessages = filteredMessages?.filter((msg:any) => msg.id !== deletedData?.messageId);

				if (callMsg?.id && !filteredMessages.some((msg:any) => msg.id === callMsg.id))
				{
					filteredMessages.push(callMsg);
				}

				if (!callMsg?.id)
				{
					await deleteMessageToLocalDb(deletedData?.messageId);
				}

				// Update local chat messages with the new state from store
				// currentChatMessages = store?.getState()?.mypresence?.chatMessages || [];

				if (!delChatList.includes(deletedData?.groupId))
				{
					const foundRoom:any = allChatRoom.find((room:any) => room?.id === deletedData?.groupId);
					const isPartOfGroup = foundRoom && foundRoom?.members?.some((memberId) => memberId === userData?.userId);

					(foundRoom && !isPartOfGroup) && delChatList.push(deletedData?.groupId);
				}
			}
			if (isChatDeletedFromCurrentOpenedRoom)
			{
				dispatch(setChatMessages([ ...filteredMessages ]));
			}
			delChatList.forEach(async (roomId) =>
			{
				const roomIndex = updatedPresenceList.current.findIndex((room) => room?.id === roomId);

				if (roomIndex >= 0)
				{
					updatedPresenceList.current.splice(roomIndex, 1);
					dispatch(setPresenceChatUserList(updatedPresenceList.current));
					if (myPresence?.chatRoomInfo?.id === roomId)
					{
						dispatch(setChatRoomInfo({}));
					}
					await deleteGroupFromPresenceDb(roomId);
				}
			});
		}
		catch (error)
		{
			console.error('Error in handleDeletedData:', error);
		}
	};

	const handleGroupListenerUpdates = async (response) =>
	{
		const myPresence = store?.getState()?.mypresence;
		let localDbGroupsIds = updatedPresenceList.current?.map((i:any) => i?.id);

		for (const change of response.docChanges())
		{
			let updatedGroupData = change.doc.data();

			// Get the previous state of this document
			const index = updatedPresenceList.current.findIndex((each:any) => each?.id === updatedGroupData?.id);
			const previousGroupData = index !== -1 ? updatedPresenceList.current[index] : null;

			localDbGroupsIds = localDbGroupsIds?.filter((i) => i !== updatedGroupData?.id);
			// const thisUserData = updatedGroupData?.membersDetails?.[userData?.userId];

			// below line needs to uncomment **imp
			// dispatch(setMsgIndicator(thisUserData?.unseenMsgCount > 0 && !window.location.pathname.includes('presence')));

			const deletedMember = updatedGroupData?.groupDeletedMembers?.find((member) => member.userId === userData?.userId);

			// Users that exit or are removed from groups are removed from members from the backend, so the change.type === 'removed' will be triggered, and the user will not get the updated data, so we're updating using 'removed' status instead.
			if (change.type === 'removed')
			{
				// add userdata code

				const res = await getDocByDocumentId('groups', updatedGroupData?.id);

				updatedGroupData = {
					...updatedGroupData,
					...res?.data(),
					membersDetails : { ...res?.data()?.membersDetails }
				};

			dispatch(setPresenceChatUser({ ...updatedGroupData }));
			await updateEntireGroupData(updatedGroupData?.id, updatedGroupData);
		}

		// Prevent msgStatus from decreasing when lastMessageId is the same
			// This handles race conditions from direct updates
			if (previousGroupData?.msgStatus && updatedGroupData?.msgStatus &&
				previousGroupData?.lastMessageId === updatedGroupData?.lastMessageId)
			{
				// If same message, status should only increase (1→2→3), never decrease
				if (updatedGroupData?.msgStatus < previousGroupData?.msgStatus)
				{
					console.log(`Preventing msgStatus decrease from ${previousGroupData?.msgStatus} to ${updatedGroupData?.msgStatus} for same message`);
					updatedGroupData = { ...updatedGroupData, msgStatus: previousGroupData?.msgStatus };
				}
			}

			// Current chatRoomInfo will be updated if it already exists.
			if (myPresence?.chatRoomInfo?.id === updatedGroupData?.id)
			{
				dispatch(setChatRoomInfo({ ...updatedGroupData }));
				unseenCountUpdate(updatedGroupData, userData?.userId);
			}

			// Determine if the updated group data should be added back to the list
			// If the user has deleted the chat, only include it if the message is newer than the deletion timestamp
			// If the user has not deleted the chat, include the updated data unconditionally

			const shouldUpdatePresence = (!deletedMember || (new Date(updatedGroupData?.recentMessageTime) > new Date(deletedMember?.timestamp)));

			if (shouldUpdatePresence)
			{
				if (index === -1)
				{
					if (initialRender)
					{
						updatedPresenceList.current?.push(updatedGroupData);
					}
					else
						if (!updatedGroupData?.blockedBy?.some((user) => user.id === userData?.userId))
						{
							updatedPresenceList.current?.unshift(updatedGroupData);
						}
				}
				else
					if (updatedGroupData?.recentMessageTime > updatedPresenceList.current[index]?.recentMessageTime)
					{
						if (!updatedGroupData?.blockedBy?.some((user) => user.id === userData?.userId))
						{
							updatedPresenceList.current?.splice(index, 1);
							updatedPresenceList.current?.unshift(updatedGroupData);
						}
					}
					else
					{
						updatedPresenceList.current[index] = updatedGroupData;
					}
			}
			else
				if (index !== -1)
				{
					updatedPresenceList.current?.splice(index, 1);
					if (myPresence?.chatRoomInfo?.id === updatedGroupData?.id)
					{
					// console.log("chatRoomInfochatRoomInfochatRoomInfo",store.getState()?.userData?.chatRoomInfo)
					// console.log("updatedGroupDataupdatedGroup---------",updatedGroupData)
						dispatch(setChatRoomInfo({}));
					}
				}
		}
		if (localDbGroupsIds?.length > 0 && initialRender)
		{
			updatedPresenceList.current = updatedPresenceList.current?.map((group) =>
			{
				if (localDbGroupsIds?.includes(group?.id))
				{
					const updatedData = {
						...group,
						members        : group?.members?.filter((i) => i !== userData?.userId),
						membersDetails : {
							...group?.membersDetails,
							[userData?.userId] : { ...group?.membersDetails?.[userData?.userId]
								// removedStatus: {
								//   status: true
								//   }
							}
						}
					};

					Boolean(group?.id === myPresence?.chatRoomInfo?.id) && dispatch(setChatRoomInfo({ ...updatedData }));

					return { ...updatedData };
				}
				else
				{
					return group;
				}
			});
		}

		// Sort the list by recentMessageTime in descending order (newest first) as safety net
		// Only needed during initial render due to potential race conditions, but kept as safety net
		if (initialRender)
		{
			updatedPresenceList.current.sort((a, b) =>
			{
				const timeA = new Date(a?.recentMessageTime || 0).getTime();
				const timeB = new Date(b?.recentMessageTime || 0).getTime();

				return timeB - timeA; // descending order
			});
		}

		// Dispatch the sorted list to update the presence chat user list
		dispatch(setPresenceChatUserList([ ...updatedPresenceList.current ]));
		dispatch(setIsChatLoaded(true));
		await addGroupsToPresenceDb(updatedPresenceList.current);

		initialRender = false;
	};

	const handleBroadcastListener = async (response) =>
	{
		let allData = await getBroadcastList() ?? [];

		await Promise.all(response.docChanges().map(async (change) =>
		{
			const broadcastData = change.doc.data();

			const res = await getDocumentFromIdb('broadcasts', broadcastData?.id);

			if (!res)
			{
				await addDocumentToIdb('broadcasts', broadcastData);
				allData.push(broadcastData);
			}
			else if (compareObjData(res, broadcastData))
			{
				await updateDocumentInIdb('broadcasts', broadcastData?.id, broadcastData);

				allData = allData.filter((item) => item?.id !== broadcastData?.id);

				broadcastData?.recentMessageTime > allData[0]?.recentMessageTime
					? allData.unshift(broadcastData)
					: allData.push(broadcastData);
			}
		}));
		dispatch(setBroadcastChatUserList(allData));
	};

	const removeGroupFromPresenceList = async (groupId) =>
	{
		const groupsDataFromLocalDb = await getAllGroups();

		updatedPresenceList.current = groupsDataFromLocalDb || [];
	};

	const handleUser = async (response) =>
	{
		const myPresence = store?.getState()?.mypresence;

		if (myPresence?.userStatus !== response.status)
		{
			dispatch(setUserStatus(response.status));
		}
	};

	const getGroupDataFromLocalDb = async () =>
	{
		const groupsDataFromLocalDb = await getAllGroups();

		updatedPresenceList.current = groupsDataFromLocalDb || [];
	};

	const handleLogoutForCollaboration = async () =>
	{
		try
		{
			const deviceData = sessionStorage.getItem('deviceData');

			if (deviceData)
			{
				const	parseDeviceData = JSON.parse(deviceData);

				await removeUserOnlineStatus(userData?.userId, parseDeviceData?.deviceId);// to update that the user is in OFFLINE
			}

			// to update that the user is in OFFLINE
			if (userData?.presenceEnabled)
			{
				const token = sessionStorage.getItem('fcmToken');

				if (token)
				{
					const companyList = userData?.companyList || [];
					const notificationPromises = companyList.map((company) =>
												manageNotifications({ userId: company?.userId, token, subscribe: false, scenario: 'login' })
													.catch((err) => console.error(`Error managing notifications for userId ${company?.userId}:`, err))
											);

											await Promise.all(notificationPromises);
				}
				// Remove FCM tokens from ALL userIds in companyList
				const companyList = userData?.companyList || [];

				const tokenRemovalPromises = companyList.map(async (company) =>
				{
					try
					{
						const companyUserRes = await getDocByDocumentId('users', company?.userId);

						if (companyUserRes?.exists())
						{
							let existingTokens = [];

							if (companyUserRes.data()?.inLynkTokens?.webTokens)
							{
								existingTokens = companyUserRes.data()?.inLynkTokens?.webTokens?.filter((prevToken) => prevToken !== token);
							}

							await updateDocByDocumentId('users', company?.userId, {
								isOnline              : false,
								updatedAt             : new Date().valueOf(),
								'inLynkTokens.webTokens' : existingTokens
							});
						}
					}
					catch (err)
					{
						console.error(`Error removing token for userId ${company?.userId}:`, err);
					}
				});

				await Promise.all(tokenRemovalPromises);

				await deleteToken(firebaseMessaging);
				const auth = getAuth();

				await signOut(auth);
			}
		}
		catch (err)
		{
			console.log(err, 'error========');
		}
	};

	const chatRoomInfo = store?.getState()?.mypresence?.chatRoomInfo;
	const chatMessages = store?.getState()?.mypresence?.chatMessages;

	const { peerData, myData } = useContext(CollaborationContext);

	// eslint-disable-next-line no-unused-vars
	const isPrivateReadReceipt = async (peerUserId:any) =>
	{
		if (!peerUserSettings)
			{
				// when chat is opened for the first time, the peerUserSettings is taking time to set the data
				const peerUserData = await getDocByDocumentId('users', peerUserId);

				dispatch(setPeerUserSettings(peerUserData?.data()));
				peerUserSettings = peerUserData?.data();
			}
		if (!currentUserSettings?.isPrivateReadreceipt || !peerUserSettings?.isPrivateReadreceipt)
			{
				return true;
			}

		return false;
	};

	const handleBlueTicksForChat = async (reqAccepted = false, roomInfo:any = null) =>
	{
		// called whenever new message is received from peer or another chat is opened
		// or when user accepts the request to chat
		const currentRoomInfo = roomInfo || chatRoomInfo;

		if (currentRoomInfo?.chatType === PRESENCE_ENUMS.individual)
		{
			const msgsSentByPeer:any = chatMessages?.filter((msg:any) => msg?.senderId === peerData?.userId && msg?.msgStatus < 3 && !msg?.notVisibleMembers?.includes(userData?.userId));

			if (msgsSentByPeer?.length > 0)
			{
				// Read settings from Redux (cached from listeners) - no Firebase calls needed!
				// Check if both users have read receipts enabled
				if (await isPrivateReadReceipt(peerData?.userId))
				{
					return;
				}

				if (!reqAccepted && !currentRoomInfo?.isReqAccepted)
				{
					return;
				}

				// Check if document/tab is visible before updating read status
				if (!isDocumentVisible())
				{
					// Store pending update to process when user becomes visible
					pendingReadUpdateRef.current = {
						msgsSentByPeer,
						currentRoomInfo,
						reqAccepted
					};

					return;
				}

				// Clear any pending update since we're processing now
				pendingReadUpdateRef.current = null;
				await updateMultipleDocuments('messages', msgsSentByPeer, { msgStatus: 3 });
				if (currentRoomInfo?.lastMessageId === msgsSentByPeer[msgsSentByPeer?.length - 1]?.id)
				{
					// updating double tick to green ticks after matching last message id from chatRoomInfo
					// and current chat's last message
					await updateDocByDocumentId('groups', currentRoomInfo?.id, { msgStatus: 3 });
				}
			}
		}
	};

	const handleBlueTicksForChatList = async () =>
	{
		if (chatRoomInfo?.chatType !== PRESENCE_ENUMS.individual) return;

		const lastMessage:any = chatMessages?.[chatMessages?.length - 1];

		if (!lastMessage) return;

		// Check if message belongs to current chat room
		const isMessageInCurrentChat = chatRoomInfo?.id === lastMessage?.chatId;

		if (!isMessageInCurrentChat) return;

		const isLastMessageFromPeer = lastMessage?.senderId !== userData?.userId;
		const isLastMessageInChatRoom = chatRoomInfo?.lastMessageId === lastMessage?.id;
		const isMessageNotRead = chatRoomInfo?.msgStatus < 3;
		const isMessageVisible = !lastMessage?.notVisibleMembers?.includes(userData?.userId);

		// Update if: message is from peer, is not read, is visible, and is the last message
		if (!isLastMessageFromPeer || !isLastMessageInChatRoom || !isMessageNotRead || !isMessageVisible) return;

		if (await isPrivateReadReceipt(lastMessage?.senderId))
		{
			return;
		}

		// Check if document/tab is visible before updating read status
		if (!isDocumentVisible())
		{
			// Store pending update flag to process when user becomes visible
			pendingChatListUpdateRef.current = true;

			return;
		}

		// Clear pending update flag since we're processing now
		pendingChatListUpdateRef.current = false;

		// Only update to status 3 (read) if both users have read receipts enabled and invitation is accepted
		// Block if: read receipts OFF or invitation not accepted (isReqAccepted === false)
		// Allow if: read receipts ON and invitation accepted (isReqAccepted === true or undefined for old chats)
		if (chatRoomInfo?.isReqAccepted === true)
		{
			await updateDocByDocumentId('groups', chatRoomInfo?.id, { msgStatus: 3 });
		}
	};

	// Process pending read status updates when user becomes visible
	const processPendingReadUpdates = async () =>
	{
		// Process pending chat read updates
		if (pendingReadUpdateRef.current)
		{
			const { msgsSentByPeer, currentRoomInfo } = pendingReadUpdateRef.current;

		try
		{
				// Re-verify visibility before processing
				if (!isDocumentVisible())
				{
					return;
				}
				if (await isPrivateReadReceipt(peerData?.userId))
				{
					return;
				}

				// Re-check if messages still need to be updated (in case they were updated by another process)
				const stillUnread = msgsSentByPeer.filter((msg:any) => msg?.msgStatus < 3);

				const promiss:Promise<any>[] = [];

				if (stillUnread.length > 0)
				{
					promiss.push(updateMultipleDocuments('messages', stillUnread, { msgStatus: 3 }));
					console.log('messages===============>', currentRoomInfo?.id);

					if (currentRoomInfo?.lastMessageId === stillUnread[stillUnread?.length - 1]?.id)
					{
						console.log('currentRoomInfo?.id===============>', currentRoomInfo?.id);
						promiss.push(updateDocByDocumentId('groups', currentRoomInfo?.id, { msgStatus: 3 }));
					}
				}

				if (promiss.length > 0)
				{
					await Promise.all(promiss);
				}
			}
			catch (error)
			{
				console.error('Error processing pending read updates:', error);
			}
			finally
			{
				// Clear pending update after processing
				pendingReadUpdateRef.current = null;
			}
		}

		// Process pending chat list read updates
		if (pendingChatListUpdateRef.current)
		{
			// Re-verify visibility before processing
			if (isDocumentVisible())
			{
				// Re-trigger the chat list update function
				await handleBlueTicksForChatList();
			}
		}
	};

	// Listen for visibility changes to process pending updates
	useEffect(() =>
	{
		const handleVisibilityChange = async () =>
		{
			if (isDocumentVisible())
			{
				// User became visible, process any pending read status updates
				await processPendingReadUpdates();
			}
		};

		if (typeof document !== 'undefined')
		{
			document.addEventListener('visibilitychange', handleVisibilityChange);

			return () =>
			{
				document.removeEventListener('visibilitychange', handleVisibilityChange);
			};
		}
	}, []);

	return { messagesDbCallback,
		handleDeletedData,
		handleBroadcastMessages,
		unseenCountUpdate,
		handleGroupListenerUpdates,
		removeGroupFromPresenceList,
		handleUser,
		getGroupDataFromLocalDb,
		handleLogoutForCollaboration,
		handleBlueTicksForChat,
		handleBlueTicksForChatList,
		handleBroadcastListener
	};
};

export default useMessageHook;